import React from 'react';

interface MetricCardProps {
  title: string;
  value: number | string;
  icon: string;
  trend?: 'up' | 'down' | 'stable' | string;
  type?: 'default' | 'success' | 'warning' | 'error';
}

const MetricCard: React.FC<MetricCardProps> = ({ 
  title, 
  value, 
  icon, 
  trend, 
  type = 'default' 
}) => {
  const getTrendIcon = () => {
    switch (trend) {
      case 'up': return '📈';
      case 'down': return '📉';
      case 'stable': return '➡️';
      default: return '•';
    }
  };

  const formatValue = (val: number | string) => {
    if (typeof val === 'number') {
      return val.toLocaleString();
    }
    return val;
  };

  return (
    <div className={`metric-card metric-card-${type}`}>
      <div className="metric-header">
        <span className="metric-icon">{icon}</span>
        <span className="metric-title">{title}</span>
      </div>
      
      <div className="metric-value">
        {formatValue(value)}
      </div>
      
      {trend && (
        <div className="metric-trend">
          <span className="trend-icon">{getTrendIcon()}</span>
          <span className="trend-text">{trend}</span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;
